const schema = {
  type: 'object',
  properties: {
    assistant_type: {
      type: 'string',
      title: 'Assistant Type',
    },
    assistant: {
      type: 'string',
      title: 'Assistant',
    },

    version: {
      type: 'number',
      title: 'Version',
    },
    active_role: {
      type: 'string',
      title: 'Active Role',
    },
    guidance: {
      type: 'string',
      title: 'Guidance',
    },
    tokens: {
      type: 'object',
      title: 'Tokens',
      properties: {
        objective: {
          type: 'string',
          title: 'Objective',
        },
        you_are_statement: {
          type: 'string',
          title: 'You Are Statement',
        },
        class_name: {
          type: 'string',
          title: 'Class Name',
        },
        returned_object: {
          type: 'string',
          title: 'Returned Object',
        },
        returned_object_instructions: {
          type: 'string',
          title: 'Returned Object Instructions',
        },
      },
    },
    classes: {
      type: 'array',
      title: 'Classes',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            title: 'Name',
          },
          guidance: {
            type: 'string',
            title: 'Guidance',
          },
        },
      },
    },
    enabled: {
      type: 'boolean',
      title: 'Enabled',
    },
  },
  required: ['assistant'],
};

const uischema = {
  type: 'Categorization',
  elements: [
    {
      type: 'Category',
      label: 'Basic',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/assistant_type',
        },
        {
          type: 'Control',
          scope: '#/properties/assistant',
        },
        {
          type: 'Control',
          scope: '#/properties/assistantFuncTypeRead',
        },
        {
          type: 'Control',
          scope: '#/properties/assistantInstructRead',
        },
      ],
    },
    {
      type: 'Category',
      label: 'Tokens',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/tokens',
        },
      ],
    },
    {
      type: 'Category',
      label: 'Classes',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/classes',
        },
      ],
    },
    // {
    //   type: 'Category',
    //   label: 'Guidance',
    //   elements: [
    //     {
    //       type: 'Control',
    //       scope: '#/properties/guidance',
    //     },
    //   ],
    // },
    {
      type: 'Category',
      label: 'Tokenized Instructions',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/tokenizedInstructions',
        },
      ],
    },
  ],
};

const data = {};

const addAssistantWithClass = (endpoint) => {
  return {
    endpoint,
    buttonTitle: 'Add Assistant',
    schema: schema,
    uischema,
    data,
    refreshPage: true,
  };
};

module.exports = addAssistantWithClass;
